import React from 'react'
import { Grid } from 'semantic-ui-react'

const Section = ({ reversed = false, img, children }) => {
  const image = (
    <Grid.Column width={6}>
      <img src={img} />
    </Grid.Column>
  )

  const content = <Grid.Column width={10}>{children}</Grid.Column>

  return (
    <Grid stackable columns={2}>
      <Grid.Row verticalAlign="middle">
        {!reversed ? content : image}
        {!reversed ? image : content}
      </Grid.Row>
    </Grid>
  )
}

export default Section
